import React from 'react';
import { Button } from '@material-ui/core';
import {
  FiEdit as EditIcon,
  FiNavigation as NavigationIcon,
  FiDownload as DownloadIcon,
  FiCheckCircle as MarkPaidIcon,
  FiCopy as CopyIcon,
} from 'react-icons/fi';
import { TrashIcon } from '../../Icons';
import { INVOICE_STATUSES } from '../../../constants';
import { PaymentActionRenderProps } from './types';
import { BaseActionsMenuButton } from '../../Dropdowns';

const PaymentActionRenderer = ({
  data,
  isClient,
  handleClickEdit,
  handleClickPay,
  handleClickDuplicateInvoice,
  handleClickDownloadInvoice,
  handleClickDownloadAttachment,
  handleClickDelete,
  handleClickVoid,
  handleClickSend,
  handleClickMarkPaid,
  handleClickCopyPaymentLink,
  onActionMenuClick,
}: PaymentActionRenderProps) => {
  const actions = [];

  if (data && data.status === INVOICE_STATUSES.DRAFT) {
    actions.push({
      name: 'Send invoice',
      onClick: () => handleClickSend(data),
      icon: <NavigationIcon />,
    });
    if (!isClient) {
      // draft invoices can be directly set to paid be an internal user
      actions.push({
        name: 'Mark paid',
        onClick: () => handleClickMarkPaid(data),
        icon: <MarkPaidIcon />,
      });
    }
  }
  if (!isClient && data.status === INVOICE_STATUSES.DRAFT) {
    actions.push({
      name: 'Edit invoice',
      onClick: () => handleClickEdit(data),
      icon: <EditIcon />,
    });
  }
  if (
    !isClient &&
    data &&
    data.invoiceFullData &&
    data.invoiceFullData.additionalFields &&
    data.invoiceFullData.additionalFields.subscription == null
  ) {
    actions.push({
      name: 'Duplicate invoice',
      onClick: () => handleClickDuplicateInvoice(data),
      icon: <CopyIcon />,
      isDisabled: data.client && data.client.entityStatus === 'DELETED',
    });
  }
  if (data.status === INVOICE_STATUSES.OPEN) {
    if (!isClient) {
      actions.push({
        name: 'Mark paid',
        onClick: () => handleClickMarkPaid(data),
        icon: <MarkPaidIcon />,
      });
    }
  }
  if (data && data.status !== INVOICE_STATUSES.DRAFT) {
    actions.push({
      name: 'Download invoice',
      onClick: () => handleClickDownloadInvoice(data),
      icon: <DownloadIcon />,
    });
  }
  if (data.status === INVOICE_STATUSES.OPEN) {
    if (!isClient) {
      actions.push({
        name: 'Copy payment link',
        onClick: () => handleClickCopyPaymentLink(data),
        icon: <CopyIcon />,
      });
    }
  }
  if (
    data &&
    data.status !== INVOICE_STATUSES.DRAFT &&
    data.invoiceFullData &&
    data.invoiceFullData.fields.attachment
  ) {
    actions.push({
      name: 'Download attachment',
      onClick: () => handleClickDownloadAttachment(data),
      icon: <DownloadIcon />,
    });
  }
  if (!isClient) {
    if (data.status === INVOICE_STATUSES.DRAFT) {
      actions.push({
        name: 'Delete invoice',
        onClick: () => handleClickDelete(data),
        icon: <TrashIcon />,
        isDelete: true,
      });
    }
    if (data.status === INVOICE_STATUSES.OPEN) {
      actions.push({
        name: 'Void invoice',
        onClick: () => handleClickVoid(data),
        icon: <TrashIcon />,
        isDelete: true,
      });
    }
  }

  return data.status === INVOICE_STATUSES.OPEN && isClient ? (
    <Button
      color="primary"
      variant="contained"
      onClick={() => handleClickPay(data)}
    >
      Pay
    </Button>
  ) : (
    <BaseActionsMenuButton
      actions={actions}
      onActionMenuClick={onActionMenuClick}
    />
  );
};

export default PaymentActionRenderer;
